import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import {
  InterviewerRsvpDeclineIcon,
  InterviewerRsvpGoingIcon,
  InterviewerRsvpMaybeIcon,
} from '@modernloop/shared/icons';

import { ResponseStatus } from 'src/generated/mloop-graphql';

interface Props {
  dataTestId?: string;
  responseStatus: ResponseStatus | undefined | null;
}

const InterviewerRsvpIcon: FC<Props> = ({ dataTestId, responseStatus }) => {
  const { t } = useTranslation();
  const iconProps = { fontSize: 'small' as const, 'data-testid': dataTestId };

  switch (responseStatus) {
    case ResponseStatus.Accepted:
      return <InterviewerRsvpGoingIcon tooltip={t('hiring-dashboard-common:common.rsvp.going')} {...iconProps} />;
    case ResponseStatus.Declined:
      return <InterviewerRsvpDeclineIcon tooltip={t('hiring-dashboard-common:common.rsvp.declined')} {...iconProps} />;
    case ResponseStatus.Tentative:
      return <InterviewerRsvpMaybeIcon tooltip={t('hiring-dashboard-common:common.rsvp.maybe')} {...iconProps} />;
    default:
      return null;
  }
};

export default InterviewerRsvpIcon;
